import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportForm from "../common/support_form.js";

export class UcRequestModel extends IllumioEventEmitter {
    constructor() {
        super();

        let csrf = IllumioSupportForm.getCsrf();
        this.authenticity_token = (csrf) ? csrf['authenticity_token'] : null,

        this.data = null;
        this.opData = null; // Result of create/edit operations
    }

    submit(theForm) {
        console.debug(`UcRequestModel.submit()`);
        const payload = {
            authenticity_token: this.authenticity_token,
        }
        $.ajax({
            method: 'post',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(payload),
            url: theForm.action,
            // beforeSend: this.commonAjaxBeforeSendHandler.bind(this),
            error: this.submitAjaxErrorHandler.bind(this),
            success: this.submitAjaxSuccessHandler.bind(this),
        });
    }

    /**
     * ES6: Private method
     */
    submitAjaxSuccessHandler(data, textStatus, jqXHR) {
        console.debug(`submitAjaxSuccessHandler()`);
        console.debug(data);

        this.data = data;
        this.emit('renderResult', this.data);
    }

    /**
     * ES6: Private method
     */
    submitAjaxErrorHandler(jqXHR, textStatus, errorThrown) {
        console.debug(jqXHR);
        console.debug(textStatus);
        console.debug(errorThrown);
        this.emit('renderResult', {});
    }
}

export class UcRequestView extends IllumioEventEmitter {
    constructor(model) {
        super();
        this.model = model;

        this.initializeWidgets();

        this.model.on('renderResult', this.renderResult.bind(this));
    }

    initializeWidgets() {
        this.theForm = document.getElementById('ucActivationForm');
        this.ucActivateButton = document.getElementById('ucActivateButton');
        if (this.theForm) {
            this.theForm.onsubmit = this.ucActivationFormOnSubmitHandler.bind(this);
            const tncCheckbox = document.getElementById('tncCheckbox');
            if (tncCheckbox) {
                tncCheckbox.onchange = this.tncCheckboxOnChangeHandler.bind(this);
                if (this.ucActivateButton) {
                    this.ucActivateButton.onclick = this.ucActivateButtonOnClickHandler.bind(this);
                    this.ucActivateButton.disabled = true;
                }
            }
        }
    }

    renderResult(args) {
        console.debug('PortalView.renderResult(args)');
        console.debug(args);
        console.debug(this);

        if (this.theForm && this.theForm.nextElementSibling && this.model.data.message) {
            const messageDiv = this.theForm.nextElementSibling;
            messageDiv.textContent = this.model.data.message;
            messageDiv.classList.remove('hidden');
            this.theForm.classList.add('hidden');
        } else {
            console.warn(`Missing theForm and/or the next sibling message element!`);
        }
    }

    /**
     * ES6: Private method
     */
    ucActivationFormOnSubmitHandler(event) {
        console.debug(`ucActivationFormOnSubmitHandler()`);
        event.preventDefault();
        this.model.submit(this.theForm);
    }

    /**
     * ES6: Private method
     */
    tncCheckboxOnChangeHandler(event) {
        console.debug(`tncCheckboxOnChangeHandler(): `);
        console.debug(event);

        if (event.target.checked==true) {
            event.target.disabled = true;
            console.debug(this.ucActivateButton);
            if (this.ucActivateButton) {
                this.ucActivateButton.disabled = false;
            }
        }
    }

    /**
     * ES6: Private method
     */
    ucActivateButtonOnClickHandler(event) {
        console.debug(`ucActivateButtonOnClickHandler()`);
        console.debug(event);
    }
}

export class UcRequestController extends IllumioEventEmitter {
    constructor(model, view) {
        super();

        this.model = model;
        this.view = view;
    }
}
